import React from 'react';
import PropTypes from 'prop-types';
import Media from 'react-media';
import Collapsible from 'react-collapsible';

import { slugify } from 'utils/string';
import trackAction from 'utils/tracking';

import GLOBAL_MEDIA_QUERIES from 'constants/Screen';

import { IconElem, ButtonElem, Content as ContentElem } from './Faq.styles';

const getFaqIcon = (icon) => (
  <Media queries={GLOBAL_MEDIA_QUERIES} defaultMatches={{ md: true }}>
    {(matches) => {
      let size = 25;

      if (matches.xs || matches.sm) {
        size = 20;
      }

      return <IconElem icon={icon} size={size} className="absolute text-primary" />;
    }}
  </Media>
);

const triggerEvent = (question, itemState) => {
  trackAction('FAQ-accordion', question, itemState);
};

const getFaqHeadingOpen = (question) => (
  // eslint-disable-next-line max-len
  <ButtonElem>
    {getFaqIcon('plus')}
    <h4 className="text-left">{question}</h4>
  </ButtonElem>
);

const getFaqHeadingClosed = (question) => (
  // eslint-disable-next-line max-len
  <ButtonElem>
    {getFaqIcon('minus')}
    <h4 className="text-left">{question}</h4>
  </ButtonElem>
);

const getFaqItems = ({ question, answer }) => {
  return (
    <Collapsible
      key={slugify(question)}
      trigger={getFaqHeadingOpen(question)}
      triggerWhenOpen={getFaqHeadingClosed(question)}
      easing="cubic-bezier(0.25, 1, 0.5, 1)"
      onOpen={() => triggerEvent(question, 'open')}
      onClose={() => triggerEvent(question, 'close')}
      className="border-2 shadow-big rounded-base mb-3 bg-white border-basic-300"
      openedClassName="border-2 shadow-big rounded-base mb-3 bg-white border-primary"
    >
      <ContentElem
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: answer }}
      />
    </Collapsible>
  );
};

const Faq = ({ title, faqItems }) => {
  return (
    <div className="container mx-auto px-4">
      <div className="u-block-margins">
        <h2 className="h3 mb-4 lg:mb-12">{title}</h2>
        {faqItems.map(getFaqItems)}
      </div>
    </div>
  );
};

Faq.propTypes = {
  title: PropTypes.string.isRequired,
  faqItems: PropTypes.arrayOf(
    PropTypes.shape({
      question: PropTypes.string,
      answer: PropTypes.string,
    }),
  ).isRequired,
};

export default Faq;
